import React, { createContext, useState, useContext } from 'react';

const TabContext = createContext(undefined); // Ensure correct initialization

export const TabProvider = ({ children }) => {
    const [activeTab, setActiveTab] = useState("tugas");

    return (
        <TabContext.Provider value={{ activeTab, setActiveTab }}>
            {children}
        </TabContext.Provider>
    );
};

// Export the hook properly
export const useTab = () => {
    const context = useContext(TabContext);
    if (!context) {
        throw new Error("useTab must be used within a TabProvider");
    }
    return context;
};
